import { IconButton } from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import { FC, MouseEvent, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Spacing from "../../../../components/Spacing";
import TooltipPopover from "../../../../components/TooltipPopover";
import { AppResource } from "../../../../types/resource.types";

const CourtActions: FC<any> = (props) => {
  const history = useHistory();
  const [isVisible, setIsVisible] = useState(false);

  const handleNavigation = (e: MouseEvent, resource: AppResource) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(`${resource}/${props.record.id}`);
  };

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 2000);
  }, []);

  return (
    <>
      {isVisible && (
        <Spacing>
          <TooltipPopover message="Create Availability">
            <IconButton color="primary" onClick={(e) => handleNavigation(e, AppResource.courtAvailabilities)}>
              <SettingsEthernetIcon />
            </IconButton>
          </TooltipPopover>

          <TooltipPopover message="Show Calendar">
            <IconButton color="primary" onClick={(e) => handleNavigation(e, AppResource.courtsSlotsCalendar)}>
              <DateRangeIcon />
            </IconButton>
          </TooltipPopover>
        </Spacing>
      )}
    </>
  );
};

export default CourtActions;
